<template>
  <div>
    <button class="btn btn-info" @click="openFilesModal">
      <i class="mdi mdi-cloud-upload"></i> {{uploadButtonText}}
    </button>
    <section
      class="files-drag-zone"
      :class="{ 'files-drag-zone--dragover': readyToLoad }"
      @drop.prevent.stop="updateFiles($event.dataTransfer.files)"
      @dragover.prevent.stop="setReadyToLoad(true)"
      @dragleave.prevent.stop="setReadyToLoad(false)">
     <slot />
    </section>
    <input 
      hidden
      multiple
      type="file"
      ref="fileInput"
      :accept="accept"
      @input="updateFiles($event.target.files)"
    />
  </div>
</template>
<script>
export default {
  props: {
    uploadButtonText: {
      type: String,
      default: 'Upload file'
    },
    accept: {
      type: String,
      default: 'image/*'
    },
  },
  data() {
    return {
      readyToLoad: false,
    };
  },
  methods: {
    setReadyToLoad(readyToLoad) {
      this.readyToLoad = readyToLoad;
    },
    openFilesModal() {
      this.$refs.fileInput.click();
    },
    updateFiles(files) {
      this.readyToLoad = false;
      this.$emit('input', files); 
    }
  }
};
</script>
<style scoped>
.files-drag-zone {
  display: flex;
  position: relative;
  margin-top: 30px;
}

.files-drag-zone .wallpaper {
  display: none;
  position: absolute;
  height: 100%;
  width: 100%;
  flex: 1;
  top: 0;
  left: 0;
  background-color: #6fd37a;
  opacity: 0.1;
}

.files-drag-zone--dragover .wallpaper {
  display: block;
}

.files-drag-zone--dragover .placeholder button {
  color: #54667ac2;
}

.placeholder {
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  margin: 0;
}
.placeholder button {
  display: flex;
  flex: 1;
  cursor: pointer;
  height: 100%;
  justify-content: center;
  font-size: 2.2rem;
  border: 0;
  outline: 0;
  color: #54667a8a;
  background-color: transparent;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/DraggableFileInput.vue